<nav aria-label="breadcrumbs">
  <ol class="breadcrumbs" [class.truncate]="truncate">
    <li *ngFor="let link of links; let isLast = last" class="breadcrumb-item" [class]="link.className">
      <a *ngIf="link.path && !isLast" [routerLink]="link.path" queryParamsHandling="preserve"
        [attr.aria-current]="currentPath === link.key ? 'page' : null">{{ link.text }}</a>
      <a *ngIf="link.href && !isLast" [href]="link.href" [attr.aria-current]="currentPath === link.key ? 'page' : null">{{
        link.text }}
      </a>
      <div class="text-only" *ngIf="!link.href && !link.path || isLast"
        [attr.aria-current]="isLast ? 'page' : (currentPath === link.key ? 'page' : null)">{{link.text}}
      </div>
      <div *ngIf="!isLast">{{divider}}</div>
    </li>
  </ol>
</nav>